import { IFormActions } from '../../@types/entityTypes';
import React, { ReactElement, useContext, useState } from 'react';
import { WorkspaceModalOnly } from '../../components/Workspace/WorkspaceModal';
import ModalContext from '../../components/Context/ModalContext';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';
import { IGoodsReceiptLine } from '../../graphql/schema/p4types';
import {
  ALLOCATE_RECEIPTS_FIELD_NAMES,
  AllocateReceiptsFilterCondition,
  getAllocateReceiptsFilters,
} from '../purchasing/AllocateReceiptsFilters';

const LazySalesOrderLineWorkspace = React.lazy(() => import('../../views/sales/SalesOrderLineWorkspace'));

export enum GoodsReceiptAction {
  AllocateReceipts = 'GOODS_RECEIPT_ALLOCATE_RECEIPTS',
}

export const goodsReceiptFormActionsForPermissions: IFormActions<GoodsReceiptAction> = [
  { description: 'Allocate Receipts', actionReference: GoodsReceiptAction.AllocateReceipts },
];

export const useGoodsReceiptFormActions: () => [IFormActions<GoodsReceiptAction>, ReactElement | null] = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const connectedForm = useContext(ConnectedFormContext);

  const receiptLines: Array<IGoodsReceiptLine> = connectedForm?.values?.receiptLines;
  const predefinedFilters = getAllocateReceiptsFilters(receiptLines, AllocateReceiptsFilterCondition.NO_CONDITION);

  return [
    [
      {
        key: 'allocateReceipts',
        text: 'Allocate Receipts',
        condition: () => !!connectedForm.values?.id,
        actionReference: GoodsReceiptAction.AllocateReceipts,
        onClick: () => setModalOpen(true),
      },
    ],
    <WorkspaceModalOnly isOpen={modalOpen}>
      <ModalContext.Provider value={{ onClose: () => setModalOpen(false) }}>
        <LazySalesOrderLineWorkspace
          viewScreenName={'/Customers/Return/'}
          predefinedFilters={predefinedFilters}
          disableViewController={true}
          includeHeader={true}
          removeAddButton={false}
          noForm={true}
          noEdit={true}
          embeddedView={true}
          onBack={() => setModalOpen(false)}
          editInNewTab={true}
          enableRowSelect={true}
          fieldNames={['returned']}
          columnData={ALLOCATE_RECEIPTS_FIELD_NAMES}
        />
      </ModalContext.Provider>
    </WorkspaceModalOnly>,
  ];
};
